@if (!this.isMove()) {
  <button kendoButton (click)="this.onPaste()" [svgIcon]="pasteIcon" title="{{'Plakken' | translate: 'Plakken'}}"></button>

} @else {
  <button kendoButton (click)="this.onMove()" [svgIcon]="moveIcon" title="{{'Verplaatsen' | translate: 'Verplaatsen'}}"></button>

}

<kendo-dialog title="{{this.dialogTitle()}}" width="500px" *ngIf="this.showDialog" (close)="this.onCancel()">
  <kendo-dialog-titlebar>
    <div style="font-size: 18px; line-height: 1.3em;">
      Kies Start Kanalen
    </div>
  </kendo-dialog-titlebar>

  <div class="main-wrapper">
    @if (!this.isMove() && !this.isModule) {
      <div class="row">
        <div class="label">{{'Afdeling titel:' | translate: 'Afdeling titel:'}}</div>
        <kendo-textbox [(value)]="this.title" style="width: 157px;" [maxlength]="8"></kendo-textbox>
      </div>

    }
    @if (this.aiRange) {
    <div class="row">
      <div class="label">{{'AI Start Kanaal:' | translate: 'AI Start Kanaal:'}}</div>
      <kanaal-input [initialValue]="this.aiRange" (valueChanged)="this.aiRange = $event" [showCheckboxes]="false" [showLabel]="false" />
    </div>
    }
    @if (this.aoRange) {
    <div class="row">
      <div class="label">{{'AO Start Kanaal:' | translate: 'AO Start Kanaal:'}}</div>
      <kanaal-input [initialValue]="this.aoRange" (valueChanged)="this.aoRange = $event" [showCheckboxes]="false" [showLabel]="false"/>
    </div>
    }
    @if (this.diRange) {
    <div class="row">
      <div class="label">{{'DI Start Kanaal:' | translate: 'DI Start Kanaal:'}}</div>
      <kanaal-input [initialValue]="this.diRange" (valueChanged)="this.diRange = $event" [showCheckboxes]="false" [showLabel]="false"/>
    </div>
    }
    @if (this.doRange) {
    <div class="row">
      <div class="label">{{'DO Start Kanaal:' | translate: 'DO Start Kanaal:'}}</div>
      <kanaal-input [initialValue]="this.doRange" (valueChanged)="this.doRange = $event" [showCheckboxes]="false" [showLabel]="false"/>
    </div>
    }
  </div>

  <kendo-dialog-actions>
    <button kendoButton (click)="onCancel()">
      {{'Cancel' | translate: 'Cancel'}}
    </button>
    <button kendoButton (click)="onConfirmAction()" themeColor="primary">
      Ok
    </button>
  </kendo-dialog-actions>
</kendo-dialog>